import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Package, PackageWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdatePackage(): UseMutationResult<
  AxiosResponse<Package>,
  AxiosError<ErrorMessage>,
  PackageWrite
> {
  const queryClient = useQueryClient();

  const updatePackage = useCallback((request: PackageWrite): Promise<AxiosResponse<Package>> => {
    return client.put(`packages/${request.packageId}/`, request);
  }, []);

  return useMutation(updatePackage, {
    onSuccess: () => {
      queryClient.invalidateQueries('packageCategories');
      queryClient.invalidateQueries('packages');
      queryClient.invalidateQueries('billingPlans');
      queryClient.invalidateQueries('athletePackages');
    },
  });
}
